
document.addEventListener("DOMContentLoaded", function () {
  const offset = 150;
  const navLinks = Array.from(document.querySelectorAll(".sticky-nav__link"));
  const mobileNavLinks = Array.from(document.querySelectorAll(".sticky-nav__link-mobile"));
  const sectionIds = navLinks.map(link => link.getAttribute("href").replace("#", ""));
  const sections = sectionIds.map(id => document.getElementById(id));
  const navBar = document.querySelector(".sticky-nav");

  function setActiveNav() {
    const scrolled = window.scrollY > 0;
    let activeIndex = 0; // Default to first section

    // Use a threshold from the top of the viewport
    const threshold = 200;

    // Loop through all sections to find which one is currently in view
    for (let i = sections.length - 1; i >= 0; i--) {
      const section = sections[i];
      if (!section) continue;

      // Get the section's position relative to the viewport
      const rect = section.getBoundingClientRect();
      const sectionTop = rect.top + window.scrollY;

      // Check if we've scrolled past this section's top (accounting for threshold)
      if (window.scrollY + threshold >= sectionTop) {
        activeIndex = i;
        break;
      }
    }

    navLinks.forEach((link, i) => {
      link.classList.toggle("active-nav", i === activeIndex);
    });
    mobileNavLinks.forEach((link, i) => {
      link.classList.toggle("active-nav", i === activeIndex);
    });
    if (navBar) {
      // Show menu as soon as user scrolls even 1px
      navBar.classList.toggle("show", scrolled);
    }
  }

  window.addEventListener("scroll", setActiveNav);
  setActiveNav();

  navLinks.forEach((link, i) => {
    link.addEventListener("click", function (e) {
      e.preventDefault();
      const targetId = sectionIds[i];
      const targetSection = sections[i];
      if (targetSection) {
        window.scrollTo({
          top: getSectionTop(targetSection) - offset,
          behavior: "smooth"
        });
      }
    });
  });

  mobileNavLinks.forEach((link, i) => {
    link.addEventListener("click", function (e) {
      e.preventDefault();
      const targetId = sectionIds[i];
      const targetSection = sections[i];
      if (targetSection) {
        window.scrollTo({
          top: getSectionTop(targetSection) - offset,
          behavior: "smooth"
        });
      }
      const mobileModal = document.querySelector(".sticky-nav__mobile-modal");
      if (mobileModal) mobileModal.style.display = "none";
    });
  });

  // Mobile modal toggle
  const mobileNav = document.querySelector(".sticky-nav__mobile");
  const mobileModal = document.querySelector(".sticky-nav__mobile-modal");
  if (mobileNav && mobileModal) {
    mobileNav.addEventListener("click", function () {
      mobileModal.style.display = mobileModal.style.display === "flex" ? "none" : "flex";
    });
    document.addEventListener("click", function (e) {
      if (
        mobileModal.style.display === "flex" &&
        !mobileModal.contains(e.target) &&
        !mobileNav.contains(e.target)
      ) {
        mobileModal.style.display = "none";
      }
    });
  }

  // Back to top
  const backToTopLink = document.querySelector(".sticky-nav__back-to-top");
  if (backToTopLink) {
    backToTopLink.addEventListener("click", function (e) {
      e.preventDefault();
      window.scrollTo({ top: 0, behavior: "smooth" });
    });
  }
});